import React, { useEffect, useState } from "react";
import { Button, Container, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { loadTemplateToDetailsTab } from "../../actions/ManagePrescriptionAction";
import { AssetStore } from "../../assets/AssetsStore";
import { DUMMY_PRESCRIPTION } from "../../Helpers/Constants";
import {
  getLastPrescription,
  getLastPrescriptionAvailability,
  savePrescription,
  getmappedtemplateAvailability,
  viewTemplates,
  autosavePrescription,
  getPrescriptionAvailability,
} from "../../reducers/symptom.api";
import DetailsTab from "./Components/DetailsTab/DetailsTab";
import LastPrescriptionTab from "./Components/LastPrescriptionTab/LastPrescriptionTab";
import ConformationModal from "./Components/Modals/ConformationModal/ConformationModal";
import InformationModal from "./Components/Modals/InformationModal/InformationModal";
import PrintPreviewTab from "./Components/PrintPreviewTab/PrintPreviewTab";
import TemplatesTab from "./Components/TemplatesTab/TemplatesTab";
import PrescriptionDisplayModal from "../../components/PrescriptionDisplayModal/PrescriptionDisplayModal";
import styles from "./printprescription.module.scss";
import { Skeleton } from "antd";
import { DrDashboardContext } from "../DoctorDashboard/DoctorDashboard";

export const PrescriprionContext = React.createContext({});
export const PrescriprionProvider = PrescriprionContext.Provider;

function PrintPrescription() {
  let dispatch = useDispatch();
  let history = useHistory();
  const [isLastPrescriptionAvailable, setIsLastPrrescription] = useState(false);
  const [isAutoSaveAvailable, setIsAutoSaveAvailable] = useState(false);

  const { _appointmentId } = useParams();

  const { drDashboardData } = React.useContext(DrDashboardContext);
 
  console.log("drDashboardData",React.useContext(DrDashboardContext))
  const [tabHeaders, setTabHeaders] = useState([
    {
      name: "Details",
    },
    // {
    //   name: "Print preview",
    // },
    // {
    //     name: "Templates"
    // },{name: "Last Prescription"}
  ]);

  const items = [
    {
      label: <a href="https://www.antgroup.com">1st menu item</a>,
      key: "0",
    },
    {
      label: <a href="https://www.aliyun.com">2nd menu item</a>,
      key: "1",
    },
    {
      type: "divider",
    },
    {
      label: "3rd menu item",
      key: "3",
    },
  ];

  const [activeTab, setActiveTab] = useState(tabHeaders[0].name);
  const [selectedTemplate, setActiveTemplate] = useState();
  const [isMessageOPen, setMessageOpen] = useState(false);
  const [isLoadLastModal, setLoadLastModal] = useState(false);
  const [isAutosaveModal, setIsAutosaveModal] = useState(false);
  const [isLoadTemplateModal, setisLoadTemplateModal] = useState(false);
  const [isCompleted, setCompleted] = useState(false);
  const [isSubmitVisible, setIsSubmitVisible] = useState(false);
  const [isAutosave, setIsAutosave] = useState(false);
  let [prescriptoinList, setPrescriptionList] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [TemplateName, setTemplateName] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [isloading, setIsloading] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [appointmentId] = useState(
    _appointmentId || drDashboardData?.appointmentId
  );
  const [isPageloading, setPageLoading] = useState(true);

  // const handleManageIsOpen = (flag) => setOpen(flag || false);

  const handleManageIsOpen = () => {
    togglehandleManageIsOpen(isOpen ? false : true);
  };

  const togglehandleManageIsOpen = (param) => setOpen(param ? param : false);

  const handleSelect = (eventKey) => {
    setSelectedItem(eventKey);
  };
  // const {
  //   patient_id,
  //   patient_name,
  //   date,
  //   gender,
  //   height_value,
  //   height_messurment,
  //   weight_value,
  //   weight_messurment,
  //   lmp,
  //   medicalHistory,
  //   medical_history_note,
  //   vaccinationStatus,
  //   vaccinationDoseCount,
  //   nonVaccinationReason,
  //   examinations,
  //   diagnosis,
  //   investigations,
  //   instructions,
  //   medications,
  //   followup_date,
  //   speciality,
  //   referral,
  //   referral_note,
  //   symptoms,
  // } = useSelector((state) => state?.managePrescription?.submissionData);

  const [wholeData, setWholeData] = useState({
    patientId: "",
    patientName: "",
    date: "",
    gender: "",
    heightValue: "",
    heightMessurment: "",
    weightValue: "",
    weightMessurment: "",
    lmp: "",
    medicalHistory: [],
    medicalHistoryNote: "",
    vaccinationStatus: false,
    vaccinationDoseCount: 0,
    nonVaccinationReason: "",
    examinations: [],
    diagnosis: [],
    investigations: [],
    investigationNote: "",
    instructions: [],
    instructionNote: "",
    medications: [],
    followUpDate: "",
    speciality: "",
    referral: "",
    referralNote: "",
    symptoms: [],
    issubmitvisible: false,
  });

  const handlePreviousPrescriptionAvailability = (res) => {
    //setIsLastPrrescription(res.enablePreload);
    // setIsAutoSaveAvailable(res.autoSaveAvailable);
    console.log("res.info");
  };

  const handletemplateAvailability = (res) => {
    // setIsLastPrrescription(res.info);
    console.log("handletemplateAvailability", res);
    setPrescriptionList(res);
  };

  const handlepreviewEnable = () => {
    if (
      (wholeData.patientId && wholeData.patientName) ||
      (wholeData.symptoms && wholeData.symptoms.length > 0) ||
      (wholeData.medicalHistory && wholeData.medicalHistory.length > 0) ||
      (wholeData.examinations && wholeData.examinations.length > 0) ||
      wholeData.diet > 0 ||
      (wholeData.Diagnosis && wholeData.Diagnosis.length > 0) ||
      (wholeData.investigations && wholeData.investigations.length > 0) ||
      (wholeData.instructions && wholeData.instructions.length > 0) ||
      (wholeData.medications && wholeData.medications.length > 0) ||
      (wholeData.speciality && wholeData.speciality.length > 0
        ? wholeData.referral &&
          wholeData.referral.length > 0 &&
          wholeData.referralNote &&
          wholeData.referralNote.length > 0
        : false)
    ) {
      setIsEnabled(false);
    } else {
      setIsEnabled(true);
    }
  };
  useEffect(() => {
    if (
      wholeData.patientId &&
      wholeData.appointmentId &&
      wholeData.doctorCode
    ) {
      getLastPrescriptionAvailability(
        wholeData.appointmentId,
        wholeData.doctorCode,
        wholeData.patientId,
        handlePreviousPrescriptionAvailability
      );
    }
  }, [wholeData.patientId, wholeData.appointmentId, wholeData.doctorCode]);

  useEffect(() => {
    if (appointmentId) {
      setPageLoading(true);
      getPrescriptionAvailability(appointmentId, handleLoadLastPrescription);
    }
  }, [wholeData.doctorCode]);

  const handleWholeData = (key, data) => {
    setWholeData((oldData) => ({ ...oldData, [key]: data }));
    handlepreviewEnable();
  };

  let submissionData = useSelector(
    (state) => state?.managePrescription?.submissionData
  );

  const handleTabHeaderClick = (tab) => {
    setActiveTab(tab.name);
  };

  let separatePrescriptionList = (para_array, para_element) => {
    let newArray = [];

    para_array.map((element) => {
      newArray.push(element[para_element]);
    });

    return newArray;
  };

  let handleAutosave = () => {
    setIsSaving(true);
    setIsAutosave(true);
    var todayDate = new Date();
    var todayTime = todayDate.getHours() + ":" + todayDate.getMinutes();
    var dd = String(todayDate.getDate()).padStart(2, "0");
    var mm = String(todayDate.getMonth() + 1).padStart(2, "0");
    var yyyy = todayDate.getFullYear();
    todayDate = dd + "/" + mm + "/" + yyyy;

    let submissionObject = {
      browserTimeZone: "",
      generalDetails: {
        doctorId: wholeData.doctorCode,
        appointmentId: wholeData.appointmentId,
        doctorName: wholeData.doctorName,
        doctorQualification: wholeData.doctorQualification,
        licenseNumber: wholeData.registrationNumber,
        doctorAddressLine1: "Pokhran Road No. 2",
        doctorAddressLine2: "Thane (W)",
        cityPin: "Mumbai - 400610",
        isSignatureAvailable: false,
        patientId: wholeData.patientId,
        patientName: wholeData.patientName,
        patientAge: wholeData.patientAge,
        patientGender: wholeData.gender,
        displayDate: wholeData.appointmentdate,
        displayTime: wholeData.appointmenttime,
        height:
          wholeData.heightValue != "0"
            ? wholeData.heightValue
            : "" + " " + wholeData.heightMessurment,
        heightUnit: wholeData.heightMessurment,
        weight:
          wholeData.weightValue != "0"
            ? +wholeData.weightValue
            : "" + " " + wholeData.weightMessurment,
        weightUnit: wholeData.weightMessurment,
        lmp: wholeData.lmp,
      },
      patientDetails: {
        patientId: wholeData.patientId,
        patientName: wholeData.patientName,
        dob: wholeData.date,
        gender: wholeData.gender,
        height: wholeData.heightValue + " " + wholeData.heightMessurment,
        heightUnit: wholeData.heightMessurment,
        weight: wholeData.weightValue + " " + wholeData.weightMessurment,
        weightUnit: wholeData.weightMessurment,
        lmp: wholeData.lmp,
      },
      consultationNotes: {
        symptoms: wholeData.symptoms,
        medicalHistory: wholeData.medicalHistory,
        medicalHistoryNote: wholeData.medicalHistoryNote,
        examinations: wholeData.examinations,
        diagnosis: wholeData.Diagnosis,
        vaccinationStatus: wholeData.vaccinationStatus,
        vaccinationDoseCount: wholeData.vaccinationDoseCount,
        vaccinationNames: [],
        nonVaccinationReason: wholeData.nonVaccinationReason,
      },
      treatmentAdvice: {
        investigations:
          wholeData.investigations != "" && wholeData.investigations.length > 0
            ? wholeData.investigations
            : [],
        instructions: wholeData.instructions,
        medications: wholeData.medications,
        diet: wholeData.diet,
      },
      followup: {
        date: wholeData.followUpDate,
      },
      referral: {
        speciality: wholeData.speciality,
        referral: wholeData.referral,
        referral_note: wholeData.referral_note,
      },
    };

    if (
      wholeData.vaccinationDoseCount &&
      Number(wholeData.vaccinationDoseCount) > 0
    ) {
      [...Array(wholeData.vaccinationDoseCount)].map((each, key) => {
        if (submissionData[`vaccinationName${key + 1}`]) {
          submissionObject.consultationNotes.vaccinationNames.push(
            submissionData[`vaccinationName${key + 1}`]
          );
        }
      });
    }
    console.log("auto save", submissionObject);
    console.log(wholeData);
    autosavePrescription(submissionObject, autosaveres);

    // setCompleted(true);
    //history.push("/Success")
  };

  const autosaveres = (res) => {
    if (res) {
      setTimeout(() => {
        setIsSaving(false);
        setIsAutosave(false);
      }, 6000);
    }
  };

  const getActiveComponent = () => {
    switch (activeTab) {
      case tabHeaders[0].name:
        return <DetailsTab />;
      // case tabHeaders[1].name:
      //   return <PrintPreviewTab />;
      // case tabHeaders[2].name:
      //   return <TemplatesTab />;
      // case tabHeaders[3].name:
      //   return <LastPrescriptionTab />;
      default:
        break;
    }
  };

  const handleWholeDataFromPrevPrescriptions = (data) => {
    const consultationNotes = data.consultationNotes;
    const treatmentAdvice = data.treatmentAdvice;
    const referalData = data.referral;
    const patientData = data.generalDetails;

    handleWholeData(
      "heightValue",
      patientData.height.trim().length > 0
        ? patientData.height.replace(patientData.heightUnit, "")
        : ""
    );
    handleWholeData("heightMessurment", patientData.heightUnit);
    handleWholeData(
      "weightValue",
      patientData.weight.trim().length > 0
        ? patientData.weight.replace(patientData.weightUnit, "")
        : ""
    );
    handleWholeData("weightMessurment", patientData.weightUnit);
    handleWholeData("lmp", patientData.lmp);
    handleWholeData("diet", treatmentAdvice.diet);

    handleWholeData("symptoms", consultationNotes.symptoms);
    handleWholeData("examinations", consultationNotes.examinations);
    handleWholeData("medicalHistory", consultationNotes.medicalHistory);
    handleWholeData("medicalHistoryNote", consultationNotes.medicalHistoryNote);

    handleWholeData("Diagnosis", consultationNotes.diagnosis);
    handleWholeData("investigations", treatmentAdvice.investigations);
    handleWholeData("instructions", treatmentAdvice.instructions);
    handleWholeData("medications", treatmentAdvice.medications);
    handleWholeData("speciality", referalData.speciality);
    handleWholeData("referral", referalData.referral);
    handleWholeData("followUpDate", data.followup.date);
    handleWholeData(
      "vaccinationDoseCount",
      consultationNotes.vaccinationDoseCount
    );
    handleWholeData("vaccinationNames", consultationNotes.vaccinationNames);
    handleWholeData("vaccinationStatus", consultationNotes.vaccinationStatus);
    handleWholeData("vaccinationNames", consultationNotes.vaccinationNames);
    handleWholeData("vaccinationName1", consultationNotes.vaccinationName1);
    handleWholeData("vaccinationName2", consultationNotes.vaccinationName2);
    handleWholeData("vaccinationName3", consultationNotes.vaccinationName3);
    handleWholeData("vaccinationName4", consultationNotes.vaccinationName4);
  };

  const handleWholeDataFromtemplate = (data) => {
    console.log("handleWholeDataFromtemplate", data);
    const consultationNotes = data.consultationNotes;
    const treatmentAdvice = data.treatmentAdvice;
    const referalData = data.referral;
    handleWholeData("symptoms", consultationNotes.symptoms);
    handleWholeData("examinations", consultationNotes.examinations);
    handleWholeData("medicalHistory", consultationNotes.medicalHistory);
    handleWholeData("medicalHistoryNote", consultationNotes.medicalHistoryNote);
    handleWholeData("Diagnosis", consultationNotes.diagnosis);
    handleWholeData("investigations", treatmentAdvice.investigations);
    handleWholeData("instructions", treatmentAdvice.instructions);
    handleWholeData("instructionNote", treatmentAdvice.instructionNote);
    handleWholeData("medications", treatmentAdvice.medications);
    handleWholeData("speciality", "");
    handleWholeData("referral", "");
    handleWholeData("followUpDate", "");
    handleWholeData(
      "vaccinationDoseCount",
      consultationNotes.vaccinationDoseCount
    );
    handleWholeData("vaccinationNames", "");
    handleWholeData("vaccinationStatus", "");
    handleWholeData("vaccinationNames", "");
    handleWholeData("vaccinationName1", "");
    handleWholeData("vaccinationName2", "");
  };

  const getTeplateTabClass = () => {
    return `${styles.templatesTab}`;
  };

  const toggleMessageModal = (param) => setMessageOpen(param ? param : false);
  const toggleLoadLastModal = (param) =>
    setLoadLastModal(param ? param : false);
  const toggleLoadtemplaeteModal = (param) =>
    setisLoadTemplateModal(param ? param : false);
  const toggleCompletedModal = (param) => setCompleted(param ? param : false);
  const toggleautosavedModal = (param) =>
    setIsAutosaveModal(param ? param : false);

  let getDoseCountAsNumber = () => {
    if (wholeData?.vaccinationDoseCount) {
      return [...Array(Number(wholeData?.vaccinationDoseCount))];
    } else {
      return [];
    }
  };

  let handleSubmit = () => {
    if (
      (wholeData.patientId &&
        wholeData.patientName &&
        wholeData.symptoms &&
        wholeData.symptoms.length > 0) ||
      (wholeData.medicalHistory && wholeData.medicalHistory.length > 0) ||
      (wholeData.examinations && wholeData.examinations.length > 0) ||
      (wholeData.Diagnosis && wholeData.Diagnosis.length > 0) ||
      (wholeData.investigations && wholeData.investigations.length > 0) ||
      (wholeData.instructions && wholeData.instructions.length > 0) ||
      (wholeData.medications && wholeData.medications.length > 0) ||
      (wholeData.speciality && wholeData.speciality.length > 0
        ? wholeData.referral &&
          wholeData.referral.length > 0 &&
          wholeData.referralNote &&
          wholeData.referralNote.length > 0
        : false)
    ) {
      var todayDate = new Date();
      var todayTime = todayDate.getHours() + ":" + todayDate.getMinutes();
      var dd = String(todayDate.getDate()).padStart(2, "0");
      var mm = String(todayDate.getMonth() + 1).padStart(2, "0");
      var yyyy = todayDate.getFullYear();
      todayDate = dd + "/" + mm + "/" + yyyy;

      let submissionObject = {
        generalDetails: {
          doctorId: wholeData.doctorCode,
          appointmentId: appointmentId,
          doctorName: wholeData.doctorName,
          doctorQualification: wholeData.doctorQualification,
          licenseNumber: wholeData.registrationNumber,
          doctorAddressLine1: "Pokhran Road No. 2",
          doctorAddressLine2: "Thane (W)",
          cityPin: "Mumbai - 400610",
          isSignatureAvailable: false,
          patientId: wholeData.patientId,
          patientName: wholeData.patientName,
          patientAge: wholeData.patientAge,
          patientGender: wholeData.gender,
          displayDate: wholeData.appointmentdate,
          displayTime: wholeData.appointmenttime,
          height:
            wholeData.heightValue != "0"
              ? wholeData.heightValue + " " + wholeData.heightMessurment
              : "NA",
          heightUnit: wholeData.heightMessurment,
          weight:
            wholeData.weightValue != "0"
              ? wholeData.weightValue + " " + wholeData.weightMessurment
              : "NA",
          weightUnit: wholeData.weightMessurment,
          lmp: wholeData.lmp.length > 0 ? wholeData.lmp : "NA",
        },
        patientDetails: {
          patientId: wholeData.patientId,
          patientName: wholeData.patientName,
          dob: wholeData.date,
          gender: wholeData.gender,
          height:
            wholeData.heightValue != "0"
              ? wholeData.heightValue + " " + wholeData.heightMessurment
              : "NA",
          heightUnit: wholeData.heightMessurment,
          weight:
            wholeData.weightValue != "0"
              ? wholeData.weightValue + " " + wholeData.weightMessurment
              : "NA",
          weightUnit: wholeData.weightMessurment,
          lmp: wholeData.lmp,
        },
        consultationNotes: {
          symptoms: wholeData.symptoms,
          medicalHistory: wholeData.medicalHistory,
          medicalHistoryNote: wholeData.medicalHistoryNote,
          examinations: wholeData.examinations,
          diagnosis: wholeData.Diagnosis,
          vaccinationStatus: wholeData.vaccinationStatus,
          vaccinationDoseCount: wholeData.vaccinationDoseCount,
          vaccinationNames: [],
          vaccinationName1: wholeData.vaccinationName1
            ? wholeData.vaccinationName1
            : "",
          vaccinationName2: wholeData.vaccinationName2
            ? wholeData.vaccinationName2
            : "",
          vaccinationName3: wholeData.vaccinationName3
            ? wholeData.vaccinationName3
            : "",
          nonVaccinationReason: wholeData.nonVaccinationReason,
        },
        treatmentAdvice: {
          investigations:
            wholeData.investigations != "" &&
            wholeData.investigations.length > 0
              ? wholeData.investigations
              : [],
          instructions: wholeData.instructions,
          medications: wholeData.medications,
          diet: wholeData.diet,
        },
        followup: {
          date: wholeData.followUpDate,
        },
        referral: {
          speciality: wholeData.speciality,
          referral: wholeData.referral,
          referral_note: wholeData.referralNote,
        },
      };

      if (
        wholeData.vaccinationDoseCount &&
        Number(wholeData.vaccinationDoseCount) > 0
      ) {
        getDoseCountAsNumber().map((elem, key) => {
          console.log("key", wholeData[`vaccinationName${key + 1}`]);
          if (wholeData[`vaccinationName${key + 1}`]) {
            submissionObject.consultationNotes.vaccinationNames.push(
              wholeData[`vaccinationName${key + 1}`]
            );
          }
        });
        /*  [...Array(wholeData.vaccinationDoseCount)].map((each, key) => {
           console.log("key", [...Array(wholeData.vaccinationDoseCount)])
           if (submissionData[`vaccinationName${key + 1}`]) {
             console.log(submissionData[`vaccinationName${key + 1}`])
             submissionObject.consultationNotes.vaccinationNames.push(
               submissionData[`vaccinationName${key + 1}`]
             );
           }
           else
           {
             console.log("each",each)
           }
         }); */
      }
      console.log(submissionObject);
      console.log(wholeData);
      savePrescription(submissionObject, fileDownload);
      setIsloading(true);
      //history.push("/Success")
    } else {
      toggleMessageModal(true);
    }
  };

  let goToBethanySite = () => {
    window.open("http://bethanyhospital.in", "_blank");
  };

  const fileDownload = (res) => {
    setIsloading(false);
    setCompleted(true);
    // const linkSource = `data:application/pdf;base64,${res.info}`;
    // const downloadLink = document.createElement("a");
    // var currentdate = new Date();
    // const fileName = `prescription_${currentdate}.pdf`;

    // downloadLink.href = linkSource;
    // downloadLink.download = fileName;
    // downloadLink.click();
  };

  let handleLoadlastPrescriptionClick = () => {
    toggleLoadLastModal(true);
  };

  let handleLoadautosavePrescriptionClick = () => {
    toggleautosavedModal(true);
  };

  let templateOnClick = (e, name) => {
    console.log("templateclick", e);
    setTemplateName(name);
    handleWholeData("templateId", e);
    //dispatch(loadTemplateToDetailsTab(templateData));
    //setActiveTab("Details");
    toggleLoadtemplaeteModal(true);
  };

  const handleLoadLastPrescription = (res) => {
    setPageLoading(false);
    console.info("handleLoadLastPrescription", res);
    handleWholeDataFromPrevPrescriptions(res.presciption);
  };
  const handleLoadAutosavePrescription = (res) => {
    console.info("handleLoadLastPrescription", res);
    handleWholeDataFromPrevPrescriptions(res.autosavepresciption);
  };
  const handleLoadTemplate = (res) => {
    console.log("handleLoadTemplate", res[0].tempData);
    handleWholeDataFromtemplate(res[0].tempData);
  };
  let handleSubmitLoadLast = () => {
    getLastPrescription(
      wholeData.appointmentId,
      wholeData.doctorCode,
      wholeData.patientId,
      handleLoadLastPrescription
    );
    toggleLoadLastModal(false);
    setActiveTab("Details");
  };

  let handleSubmitLoadAutosave = () => {
    getLastPrescription(
      wholeData.appointmentId,
      wholeData.doctorCode,
      wholeData.patientId,
      handleLoadAutosavePrescription
    );
    toggleautosavedModal(false);
    setActiveTab("Details");
  };

  let handleSubmitLoadtemplate = () => {
    viewTemplates(wholeData.templateId, handleLoadTemplate);
    toggleLoadtemplaeteModal(false);
    setActiveTab("Details");
  };

  console.log("setSelectedItem", selectedItem);

  return (
    <div className={styles.container}>
      {isPageloading ? (
        <PageLoader />
      ) : (
        <PrescriprionProvider value={{ wholeData, handleWholeData }}>
          <div className={styles.body}>
            <div className={styles.container}>
              <div className={styles.tabBody}>
                {getActiveComponent()}

                {activeTab === tabHeaders[0].name ? (
                  <div className={styles.submit_prescription}>
                    <Button
                      onClick={handleSubmit}
                      className={styles.submit_prescription_button}
                      disabled={isloading}
                    >
                      {isloading ? "Proccessing.." : "SUBMIT"}
                    </Button>
                    {/*  <Button
                    onClick={handleManageIsOpen}
                    className={styles.submit_prescription_button}
                    disabled={isEnabled}
                    style={{marginLeft:"59px"}}
                  >
                     PREVIEW
                  </Button> */}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <PrescriptionDisplayModal
            isOpen={isOpen}
            onClose={handleManageIsOpen}
            wholeData={wholeData}
          />
          <InformationModal
            onSubmit={(e) => {
              toggleMessageModal(false);
            }}
            title={"Can't save prescription without values !!!"}
            showModal={isMessageOPen}
            hidemodal={() => {
              toggleMessageModal(false);
            }}
          />

          <ConformationModal
            onSubmit={(e) => {
              handleSubmitLoadLast();
            }}
            title={"Do you want to load the last prescription?"}
            showModal={isLoadLastModal}
            hidemodal={() => {
              toggleLoadLastModal(false);
            }}
          />

          <ConformationModal
            onSubmit={(e) => {
              handleSubmitLoadAutosave();
            }}
            title={"Do you want to load the unsaved prescription?"}
            showModal={isAutosaveModal}
            hidemodal={() => {
              toggleautosavedModal(false);
            }}
          />

          <ConformationModal
            onSubmit={(e) => {
              handleSubmitLoadtemplate();
            }}
            title={"Do you want to load the Template - " + TemplateName + " ?"}
            showModal={isLoadTemplateModal}
            hidemodal={() => {
              toggleLoadtemplaeteModal(false);
            }}
          />

          <InformationModal
            onSubmit={(e) => {
            
              // window.location.href = "https://bethanyhospital.in";
              toggleCompletedModal(false);
              history.push({
                pathname: "/dashboard",
                state: { page: "dashboard" },
              });
            }}
            title={"Prescription saved successfully."}
            showModal={isCompleted}
            hidemodal={() => {
              history.push("/dashboard");
              console.log("close")

              // window.location.href = "https://bethanyhospital.in";
              toggleCompletedModal(false);
            }}
          />
        </PrescriprionProvider>
      )}
    </div>
  );
}

export default PrintPrescription;

const PageLoader = () => {
  return (
    <>
      {[...Array(2)].map(() => (
        <Skeleton
          avatar
          paragraph={{
            rows: 4,
          }}
        />
      ))}
    </>
  );
};
